function text(value) {
  return String(value || '').trim();
}

function namesFrom(item) {
  const leads = Array.isArray(item?.leads) ? item.leads : [];
  const withParent = leads.find((lead) => text(lead?.parent_name));
  const withChild = leads.find((lead) => text(lead?.child_name));
  const parentLeadChild = text(withParent?.child_name);
  return {
    parent: text(withParent?.parent_name),
    child: parentLeadChild || text(withChild?.child_name),
    profile: text(item?.profile_name),
    phone: text(item?.e164),
  };
}

/** Inbox row title on every tab: the parent, then WhatsApp name, child, or phone. */
export function chatListTitle(item) {
  const { parent, child, profile, phone } = namesFrom(item);
  return parent || profile || child || phone;
}

/** Smaller line under the row title. */
export function chatListSubtitle(item) {
  const { parent, child } = namesFrom(item);
  if (!child) return '';
  if (!parent && child === chatListTitle(item)) return '';
  return `kid:${child}`;
}
